
import React,{useContext, useEffect, useState} from 'react'
import { useNavigate } from 'react-router-dom';
import './paginationComponent.css';

function CartPaginationComponent({ page, pages, item }) {
    
    const [pageNumber, setPageNumber] = useState(1);
    const navigate = useNavigate();

    useEffect(() => {
        if (parseInt(page) <= parseInt(pages) - 3) {
            setPageNumber(parseInt(page));
        } else {
            setPageNumber(parseInt(pages) - 3)
        }
    }, [page, pages])

    function onclickNext() {
        if (page < pages) {
            navigate(`/${item}/${parseInt(page) + 1}`)
        }
    }

    function onclickPrevious() {
        if (page > 1) {
            navigate(`/${item}/${parseInt(page) - 1}`)
        }
    }

    return (
        
        <div className="pagination">
        {
            parseInt(pages) <= 8 ? (
                <div className="pagination-content">
                    <span onClick={onclickPrevious}>
                        <i className="fa-solid fa-angle-left"></i>
                    </span>
                    <span onClick={() => navigate(`/${item}/${1}`)} > Premier </span>
                    {
                        [...Array(pages).keys()].map(x => (
                            <span key={x + 1} className={x + 1 == page ? 'page-number-active' : ''} onClick={() => navigate(`/${item}/${x + 1}`)}>
                                {x + 1}
                            </span>
                        ))
                    }
                    <span onClick={() => navigate(`/${item}/${pages}`)} > Dernier </span>
                    <span onClick={onclickNext} >
                        <i className="fa-solid fa-angle-right"></i>
                    </span>
                </div>
            ) :
                (
                    <div className="pagination-content">
                        <span onClick={onclickPrevious}>
                            <i className="fa-solid fa-angle-left"></i>
                        </span>
                        <span onClick={() => navigate(`/${item}/${1}`)} > Premier </span>
                        {
                            (pageNumber - 1 > 0) && (
                                <span onClick={() => navigate(`/${item}/${pageNumber - 1}`)} > {pageNumber - 1} </span>
                            )
                        }
                        {
                            pageNumber && (
                                <span className={pageNumber == page ? 'page-number-active' : ''} onClick={() => navigate(`/${item}/${pageNumber}`)}>
                                    {pageNumber}
                                </span>
                            )
                        }
                        {
                            (pageNumber + 1 <= pages) && (
                                <span className={pageNumber + 1 == page ? 'page-number-active' : ''} onClick={() => navigate(`/${item}/${pageNumber + 1}`)}>
                                    {pageNumber + 1}
                                </span>
                            )
                        }
                        {
                            (pageNumber === 1) && (
                                <span onClick={() => navigate(`/${item}/${pageNumber + 2}`)}>{pageNumber + 2}</span>
                            )
                        }
                        {
                            (pageNumber + 1 !== pages - 2) && (
                                <span>{'....'}</span>
                            )
                        }
                        <span onClick={() => navigate(`/${item}/${pages - 1}`)} className={pages - 1 == page ? 'page-number-active' : ''}>
                            {pages - 1}
                        </span>
                        <span onClick={() => navigate(`/${item}/${pages}`)} className={pages == page ? 'page-number-active' : ''}>
                            {pages}
                        </span>
                        <span onClick={() => navigate(`/${item}/${pages}`)} > Dernier </span>
                        <span onClick={onclickNext} >
                            <i className="fa-solid fa-angle-right"></i>
                        </span>
                    </div>
                )
        }
    </div>


    )
}

export default CartPaginationComponent
